/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDecreaseIndentRtl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 5H2v2h20zm-2.414 7-2.293-2.293 1.414-1.414L22.414 12l-3.707 3.707-1.414-1.414zM15 9H2v2h13zm0 4H2v2h13zm7 4H2v2h20z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDecreaseIndentRtl as DecreaseIndentRtl };
